module.exports = __webpack_public_path__ + "img/logo_zealy.d3cd0120.png";